import axios from 'axios'
function login (params) {
  return this.fetch({
    method: 'GET',
    url: 'main/login',
    params
  }).then((user) => {
    this.state = user
    return user
  })
}
function loginout (data) {
  return axios.post('logout', data)
}
export function sysmenu (data) {
  return this.fetch({
    method: 'POST',
    url: 'config/sysmenu',
    data
  })
}

// 获取单条标签记录
export function getProjectList (data) {
  return this.fetch({
    method: 'POST',
    url: 'project/list',
    data
  })
}

// 手机号获取验证码
export function getValidateCode (data) {
  return this.fetch({
    method: 'POST',
    url: 'api/account/getValidateCode',
    data
  })
}

// 验证码登录
export function loginByCode (data) {
  return this.fetch({
    method: 'POST',
    url: 'api/account/loginByCode',
    isLogin: true,
    data
  })
}

// 企业微信扫码登录
export function qywxLogin (params) {
  return this.fetch({
    method: 'GET',
    url: 'api/account/qyweixinLogin',
    isLogin: true,
    params
  })
}
// 飞书登录
export function feiShuLogin (params) {
  return this.fetch({
    method: 'GET',
    url: 'api/account/fsAutoLogin',
    isLogin: true,
    params
  })
}
// 飞书扫码登录
export function fsScanAutoLogin (params) {
  return this.fetch({
    method: 'GET',
    url: 'api/account/fsScanAutoLogin',
    isLogin: true,
    params
  })
}

// 共享屏登录
export function shareLogin (params) {
  return this.fetch({
    method: 'GET',
    url: 'api/account/share/login',
    isLogin: true,
    params
  })
}

// 获取登录状态
export function getLoginStatus (params) {
  return this.fetch({
    method: 'GET',
    isReturntype: true,
    useLoading: false,
    url: 'api/account/loginStatus',
    params
  })
}

// 申请查看权限
export function applyAuthority (data) {
  return this.fetch({
    isReturntype: true,
    method: 'POST',
    url: 'api/account/apply',
    data
  })
}

export {
  login,
  loginout
}
